// extracted by mini-css-extract-plugin
export default {"Debug":"Debug_Debug__+xtFE","list":"Debug_list__YYN+2"};